module.exports = __webpack_public_path__ + "img/top-10-calendar.48106954.jpg";